export const BENEFIT_PASS_ROUTE = '/pases';
export const BENEFIT_PASS_LEGACY_ROUTE = '/luxury-pass';
export const BENEFIT_PASS_API_PATH = 'luxury-pass';
export const BENEFIT_PASS_SEARCH_API_KEY = 'luxuryPass';

export function buildBenefitPassBrandHref(slug: string | null | undefined): string | null {
  const normalized = slug?.trim();
  return normalized ? `${BENEFIT_PASS_ROUTE}/marca/${encodeURIComponent(normalized)}` : null;
}

export function normalizeBenefitPassHref(href: string): string {
  if (!href) return href;
  if (href === BENEFIT_PASS_LEGACY_ROUTE) return BENEFIT_PASS_ROUTE;
  if (href.startsWith(`${BENEFIT_PASS_LEGACY_ROUTE}/`)) {
    return `${BENEFIT_PASS_ROUTE}${href.slice(BENEFIT_PASS_LEGACY_ROUTE.length)}`;
  }
  if (href.startsWith(`${BENEFIT_PASS_LEGACY_ROUTE}?`)) {
    return `${BENEFIT_PASS_ROUTE}${href.slice(BENEFIT_PASS_LEGACY_ROUTE.length)}`;
  }
  return href;
}
